<template>
  <div>

    <sklad-form :datas="dataall" v-if="dataall.id"></sklad-form>

    <!-- Saqlanmagan o'zgarishlar modali -->
    <b-modal id="modal-close" centered hide-footer no-close-on-backdrop>
      <div class="text-center p-3">
        <h5 class="mb-4">{{ $t('Sizda saqlanmagan malumotlar mavjud. Saqlansinmi?') }}</h5>
        <div class="d-flex justify-content-center" style="gap:10px">
          <button class="btn btn-success" @click="$root.$refs.sklad.Savedokument()">{{ $t('Ha') }}</button>
          <button class="btn btn-danger" @click="Home()">{{ $t("Yo'q") }}</button>
          <button class="btn btn-secondary" @click="$bvModal.hide('modal-close')">{{ $t('Bekor qilish') }}</button>
        </div>
      </div>
    </b-modal>

  </div>
</template>

<script>
import { SkladForm } from "@/pages";
export default {
  components: { SkladForm },
  data() {
    return {
      dataall: {}
    };
  },
  watch: {
    dataall: {
      deep: true,
      handler() {
        this.$store.state.saved += 1;
      }
    }
  },
  created() {
    axios.get("api/v1/sklads/id/" + this.$route.params.id).then(res => {
      this.dataall = res.data;
    });
  },
  methods: {
    Home() {
      this.$store.state.saved = 1;
      this.$bvModal.hide('modal-close');
      this.$router.push({ name: "Склад" });
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.$store.state.saved == 1) {
      this.$store.state.saved = null;
      next();
    } else {
      this.$bvModal.show("modal-close");
    }
  }
};
</script>
